import { createFileRoute } from '@tanstack/react-router'
import { MembersTable } from '../../../../modules/settings/members-table'
import { SettingsShell } from '../../../../modules/settings/settings-shell'

export const Route = createFileRoute('/_authed/settings/general/members')({
  component: () => (
    <SettingsShell>
      <MembersTable />
    </SettingsShell>
  ),
})
